import React from 'react'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'
import ReactTable from 'react-table'
import { lower } from 'change-case'
import { Icon, Button, Modal } from 'semantic-ui-react'
import deepmerge from 'deepmerge'
import Tooltip from '@material-ui/core/Tooltip';
import r from 'reactotron-react-js'

import { selectSubDeliveryType, selectMainDeliveryType } from '../../AttributeData'
import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import PanelPOInfo from '../PanelPOInfo'
import ItemTable from '../ItemTable'
import Approvers from 'routes/ProcurementSystem/Shared/DocumentStep/Approvers'
import { getSpecialApproval, getProjectByCompany } from 'ducks/goa'
import {
  filterItemPORelease,
  removeItemPORelease,
  addItemPORelease,
  resetItemPORelease,
  getPOReleaseDetail
} from 'ducks/goodsServiceReceipt'

import {
  GRContainer,
  RowFields
} from 'routes/ProcurementSystem/GoodsServiceReceipt/styled'
import { TablePO, DType } from './styled'

const Information = props => {
  const {
    isCreate = false,
    isEdit = false,
    valueForm,
    goaWorkFlow,
    pmUsers,
    projects,
    specialApprovalInfo,
    poReleaseDetail
  } = props

  var po = (valueForm&&valueForm.goodsServiceReceiptPOs&&valueForm.goodsServiceReceiptPOs.length) ? valueForm.goodsServiceReceiptPOs[0] : null
  const [showAlertNotGR, setShowAlertNotGR] = React.useState(false)


  const toFixed = (num, fixed)=> { 
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?')
    return num.toString().match(re)[0]; 
  }

  const calculateAllPOItemData = (poItems) => {
    poItems.forEach((x, i) => {
      x.totalNetAmount = Number((Number(x.netPrice) * Number(x.qtyReceive)).toFixed(2))
      // x.totalNetAmount = toFixed(Number(x.netPrice) * Number(x.qtyReceive),2)
      x.totalInvoiceAmount = Number(x.totalNetAmount) + Number(x.adjustAmount || 0)
      props.change(`goodsServiceReceiptPoItems[${i}]`, x)
    });
    return poItems
  }

  const addSelectPO = (po) => {
    let clone = JSON.parse(JSON.stringify(valueForm.goodsServiceReceiptPOs))
    clone.push(...po)
    props.change('goodsServiceReceiptPOs', clone)
    //po length == 1 is from create page
    if(po.length==1){
      if (clone.length === 1) {
        props.change('companyCode', po[0].companyCode)

        if(valueForm.vatRate==null||valueForm.vatRate==undefined){
          props.change('vatRate', po[0].vatRate)
        }
        if(!isEdit){
          if(!valueForm.projectId){
            props.change('projectId', po[0].projectId)
            props.getSpecialApproval(po[0].projectId)
          }
          if(!valueForm.specialApprovalId){
            props.change('specialApprovalId', po[0].specialApprovalId)
          }
        }
        props.filterItemPORelease(po[0].purchaseOrderSapNumber)
      } else {
        props.removeItemPORelease(po[0].purchaseOrderSapNumber)
      }
    }
  }

  const removeSelectPO = (removeIndex, po) => {
    let clone = JSON.parse(JSON.stringify(valueForm.goodsServiceReceiptPOs))
    clone.splice(removeIndex, 1)
    props.change('goodsServiceReceiptPOs', clone)
    if (clone.length) {
      props.addItemPORelease(po.sapNumber)
    } else {
      props.resetItemPORelease()
      props.change('mainDeliveryType', '')
      props.change('subDeliveryType', '')
      props.change('projectManagerUser', '')
      props.change('invoiceNumber', '')
      props.change('forPeriod', '')
      props.change('totalPeriod', '')
      props.change('totalNetAmount', '')
      props.change('withholdingTaxRate', '')
      props.change('deductDownPayment', '')
      props.change('deductRetention', '')
      props.change('totalInvoiceAmount', '')
      props.change('totalAdjustAmount', '')
      props.change('withholdingTax', '')
      props.change('otherName1', '')
      props.change('otherName2', '')
      props.change('otherName3', '')
      props.change('otherValue1', '')
      props.change('otherValue2', '')
      props.change('otherValue3', '')
      props.change('vatAmount', '')
      props.change('billingAmount', '')
      props.change('gr02', null)
      props.change('gr03', null)
      props.change('gr04', null)
      props.change('gr05', null)
      props.change('gr06', null)
      props.change('gr07', null)
      props.change('gr08', null)
    }
  }

  const updatePoItem = (isAdd, poSapNum, items) => {
    if (isAdd) {
      let clone = JSON.parse(JSON.stringify(valueForm.goodsServiceReceiptPoItems))
      items.forEach(x=>{x.qtyReceive=x.qtyReceive||0;x.totalNetAmount=0;x.totalInvoiceAmount=0;x.adjustAmount=x.adjustAmount||0})
      clone.push(...items)
      props.change('goodsServiceReceiptPoItems', clone)
      return calculateAllPOItemData(clone)
    } else {
      let clone = JSON.parse(JSON.stringify(valueForm.goodsServiceReceiptPoItems.filter(x => x.purchaseOrderSapNumber !== poSapNum)))
      props.change('goodsServiceReceiptPoItems', clone)
      return clone
    }
  }

  React.useEffect(() => {
    if(isEdit){
      if(props.poReleaseList.data.length&&valueForm.id){
        if(valueForm&&valueForm.grPos.length){
          valueForm.grPos.forEach(x=>{
            props.getPOReleaseDetail(x.purchaseOrderSapNumber, valueForm.id)
          })
        }
        props.change('grPos',[])
      }
    }
  },[(valueForm&&valueForm.id),props.poReleaseList.buffer])

  React.useEffect(()=>{
    if(Object.keys(specialApprovalInfo.data).length){
      props.change('specialApprovalName',specialApprovalInfo.data.name)
    }
  },[specialApprovalInfo.data])

  React.useEffect(()=>{
    if(valueForm.projectId){
      props.getSpecialApproval(valueForm.projectId)
    }
  },[valueForm.projectId])

  React.useEffect(()=>{
    if(props.specialApprovals[valueForm.projectId]!=undefined){
      if(props.specialApprovals[valueForm.projectId].length>0){
        let i = props.specialApprovals[valueForm.projectId].findIndex(x=>x.id==valueForm.specialApprovalId)
        if(i<0) {
          props.change('specialApprovalId',null)
        }
        //require specialApproval
        props.change('requireSpecialApproval',true)
      }else{
        props.change('specialApprovalId',null)
        props.change('requireSpecialApproval',false)
      }
    }
  },[props.specialApprovals])

  React.useEffect(()=>{
    if(valueForm.companyCode){
      props.getProjectByCompany(valueForm.companyCode)
    }
  },[valueForm.companyCode])
  
  React.useEffect(()=>{
    if(poReleaseDetail){
      if(poReleaseDetail.notGr){
        setShowAlertNotGR(true)
      }else{
        if(valueForm.grPoItems&&valueForm.grPoItems.length){
          let items = []
          let clone = JSON.parse(JSON.stringify(valueForm.grPoItems))
          poReleaseDetail.items.forEach(poRI=>{
            //delete data temp
            let basePOIndex = clone.findIndex(x=>x.lineNo==poRI.lineNo&&x.purchaseOrderSapNumber==poRI.purchaseOrderSapNumber)
            if(basePOIndex>=0){
              clone.splice(basePOIndex,1)
            }
  
            let item = valueForm.grPoItems.find(grPoI=>grPoI.lineNo==poRI.lineNo&&grPoI.purchaseOrderSapNumber==poRI.purchaseOrderSapNumber)
            if(item){
              let i = {...deepmerge(poRI,item)}
              items.push(i)
            }else{
              if(!valueForm.isFromVendor){
                if(poRI.qtyRemain>0) items.push(poRI)
              }
            }
          })
          //update delete data temp
          props.change('grPoItems',clone)
          addSelectPO([poReleaseDetail])
          updatePoItem(true, poReleaseDetail.purchaseOrderSapNumber, items)
        }else{
          addSelectPO([poReleaseDetail])
          updatePoItem(true, poReleaseDetail.purchaseOrderSapNumber, poReleaseDetail.items.filter(x=>x.qtyRemain>0))
        }
      }
    }
  },[poReleaseDetail])

  const setMember = () => {
    if(valueForm&&valueForm.requesterUser){
      let user = props.members.find(x=>x.username.toLowerCase()==valueForm.requesterUser.toLowerCase())
      if(!user){
        let result = props.members.map((m,i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
        result.push({
          key: `${lower(valueForm.requesterUser)}`,
          value: lower(valueForm.requesterUser),
          text: valueForm.requesterName
        })
        return result
      }else{
        return props.members.map((m,i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
      }
    }else{
      return []
    }
  }

  return (
    <GRContainer>
      <StdCard title={<span className='stepTitle'>Step 1 : Title</span>}
        accessoriesHeader={
          (isCreate) &&
          <React.Fragment>
            <Approvers 
              approvers={goaWorkFlow.data} 
              // status={valueForm&&valueForm.status}
              trigger={
                <Button 
                  basic  
                  circular 
                  type='button' 
                  loading={goaWorkFlow.loading} 
                  content='View Approver' 
                  labelPosition='right'
                  icon='sort numeric down' />
              }
            />
          </React.Fragment>
        }
      >
        <RowFields>
          <Field
            name='title'
            label='Title'
            type={type.text}
            component={FieldInput}
            require
            maxLength={200}
            maxLengthMessage='Title must be less than or equal to 200 characters'
          />
          <Field
            name='requesterUser'
            label='Requester'
            require
            editable={isCreate || isEdit}
            component={FieldInput}
            allowAdditions={false}
            loading={props.members.loading}
            options={setMember()}
            type={type.select}
          />
        </RowFields>
      </StdCard>
      <div style={{ marginTop: '1rem' }} />
      <StdCard title={<span className='stepTitle'>Step 2 : Select Purchase Order</span>}>
        {(valueForm&&(valueForm.status==1||valueForm.status==5))?null:
        <RowFields>
          <Field
            name="poReleaseList"
            label="Choose Purchase Order and Fill out the form"
            placeHolder="PO Number, PO Title"
            require
            component={FieldInput}
            allowAdditions={false}
            loading={props.poReleaseList.loading}
            options={props.poReleaseList.data.map(m => ({
              value: m,
              text: `${m.sapNumber} : ${m.title}`,
            }))}
            specialOnChange={(v) => {
              if (v) {
                props.getPOReleaseDetail(v.sapNumber)
                props.change('poReleaseList', null)
              }
            }}
            type={type.select}
            className='halfRow'
          />
        </RowFields>}

        {/* <div style={{ marginTop: '1rem' }} /> */}
        {!(valueForm&&valueForm.goodsServiceReceiptPOs&&valueForm.goodsServiceReceiptPOs.length>0) ? null :
          <React.Fragment>
            <RowFields>
              <TablePO>
                <ReactTable
                  data={valueForm.goodsServiceReceiptPOs}
                  columns={[
                    {
                      accessor: row => (row),
                      id: 'grPOselects',
                      Cell: row => (
                        <div className='rt-item'>
                          <Tooltip title={`${row.value.purchaseOrderSapNumber} : ${row.value.title}`} placement="top-start">
                            <div className='wordTitle'>{`${row.value.purchaseOrderSapNumber} : ${row.value.title}`}</div>
                          </Tooltip>
                          {(valueForm.status==1||valueForm.status==5)?null:
                          <Icon circular inverted link size='small' name='delete'
                            onClick={() => {
                              removeSelectPO(row.index, row.value)
                              updatePoItem(false, row.value.purchaseOrderSapNumber, null)
                            }}
                          />}
                        </div>
                      )
                    }
                  ]}
                  pageSize={(valueForm.goodsServiceReceiptPOs.length > 5 ? 5 : valueForm.goodsServiceReceiptPOs.length)}
                  showPagination={valueForm.goodsServiceReceiptPOs.length > 5}
                  resizable={false}
                  NoDataComponent={() => null}
                  previousText={<Icon name="arrow alternate circle left" />}
                  nextText={<Icon name="arrow alternate circle right" />}
                  className="-striped -highlight"
                />
              </TablePO>
            </RowFields>
          </React.Fragment>}
      </StdCard>
      <div style={{ height: '1rem' }} />
      <PanelPOInfo />
      <div style={{ marginTop: '1rem' }} />
      <StdCard title={<span className='stepTitle'>Step 3 : Delivery Type</span>}>
        <DType>
          <RowFields>
            <Field
              name='mainDeliveryType'
              label='Delivery Type'
              options={selectMainDeliveryType(props.grType.data)}
              type={type.radio}
              component={FieldInput}
              className='halfRow type'
              horizontalView
              editable={(valueForm&&(valueForm.status==1||valueForm.status==5))?false:true}
              require
            />
          </RowFields>
        </DType>
        <DType>
          <RowFields className='subDeliveryTypeC'>
            <Field
              name="subDeliveryType"
              options={selectSubDeliveryType((valueForm&&valueForm.mainDeliveryType)||null, props.grType.data)}
              loading={props.grType.loading}
              type={type.select}
              component={FieldInput}
              className="halfRow"
              editable={(valueForm.status==1||valueForm.status==9)?false:true}
              require
            />
          </RowFields>
        </DType>
      </StdCard>
      <div style={{ marginTop: '1rem' }} />
      <StdCard title={<span className='stepTitle'>Step 4 : Select Project Manager</span>}>
        <RowFields>
          <Field
            name="projectManagerUser"
            label="Select Project Manager"
            component={FieldInput}
            loading={pmUsers.loading}
            options={pmUsers.data}
            type={type.select}
            editable={isCreate || isEdit}
            className='halfRow'
          />
        </RowFields>
      </StdCard>
      <div style={{ marginTop: '1rem' }} />
      <StdCard title={<span className='stepTitle'>{'Step 5 : GR for Employee’s Advance Payment'}</span>}>
        <RowFields>
          <Field
            name="advancePayment"
            type={type.switch}
            component={FieldInput}
          />
        </RowFields>
        {valueForm.advancePayment&&<RowFields>
          <Field
            name="advancePaymentNo"
            label="Advance Payment No."
            type={type.text}
            component={FieldInput}
            className='halfRow'
            require
          />
        </RowFields>}
      </StdCard>
      <div style={{ marginTop: '1rem' }} />
      <StdCard title={<span className='stepTitle'>{`Step  6 : GR for The Final Completion(Real Estate Projects)`}</span>}>
        <RowFields>
          <Field
            name="isFinal"
            type={type.switch}
            component={FieldInput}
          />
        </RowFields>
        {valueForm.isFinal&&<RowFields>
          <Field
            name='mainContractTotalValue'
            label='Main Contract Total Value'
            fixedDecimalScale={true}
            type={type.number}
            component={FieldInput}
            suffix=' THB'
            require
          />
          <Field
            name='contractNo'
            label='Contract No.'
            type={type.text}
            component={FieldInput}
            require
          />
        </RowFields>}
      </StdCard>
      <div style={{ marginTop: '1rem' }} />
      <StdCard title={<span className='stepTitle'>{`Step 7 : Detail`}</span>}>
        <div style={{ marginTop: '1rem' }} />
        <RowFields>
          <Field
            name='projectId'
            label='Project Name'
            loading={props.projectLoading}
            options={projects.map((x,i)=>({key:i,value:x.id,text:x.projectName}))}
            type={type.select}
            editable={true}
            component={FieldInput}
            className={(valueForm.specialApprovalId&&props.specialApprovals[valueForm.projectId]&&props.specialApprovals[valueForm.projectId].length>0)?'':'halfRow'}
          />
          {valueForm.projectId&&props.specialApprovals[valueForm.projectId]&&(props.specialApprovals[valueForm.projectId].length>0)&&<Field
            name='specialApprovalId'
            label='Special Approval'
            editable={true}
            loading={props.specialApprovalLoading}
            options={props.specialApprovals[valueForm.projectId].map((x,i)=>({key:i,value:x.id,text:x.name}))}
            type={type.select}
            component={FieldInput}
          />}
        </RowFields>
        <RowFields>
          <Field
            name='documentDate'
            label='Document Date'
            type={type.date}
            component={FieldInput}
            dateFormat='dd MMM yyyy'
            editable={valueForm&&valueForm.isFromVendor?false:true}
            require
          />
          <p name='postingDate'/>
          <Field
            name='postingDate'
            label='Posting Date'
            type={type.date}
            component={FieldInput}
            dateFormat='dd MMM yyyy'
            require
          />
        </RowFields>
        <RowFields>
          <Field
            name='invoiceNumber'
            label='Invoice Number'
            type={type.text}
            component={FieldInput}
            className='halfRow'
            editable={valueForm&&valueForm.isFromVendor?false:true}
            require
          />
          <Field
            name='invoiceDate'
            label='Invoice Date'
            type={type.date}
            component={FieldInput}
            dateFormat='dd MMM yyyy'
            editable={valueForm&&valueForm.isFromVendor?false:true}
            require
          />
        </RowFields>
        <RowFields>
          <Field
            name='forPeriod'
            label='For The Period'
            type={type.text}
            component={FieldInput}
            placeHolder='Ex: 30% งวดที่1'
            className='halfRow'
            editable={valueForm&&valueForm.isFromVendor?false:true}
          />
          <Field
            name='totalPeriod'
            label='Total Period'
            type={type.text}
            placeHolder='Ex: 100% ทั้งหมด 5 งวด'
            component={FieldInput}
            className='halfRow'
            editable={valueForm&&valueForm.isFromVendor?false:true}
          />
        </RowFields>
        {(valueForm.goodsServiceReceiptPOs&&valueForm.goodsServiceReceiptPOs.length>0) ?
          <React.Fragment>
            <div className='headerText'>{`${po.vendorCode} | ${po.vendorName}`} <span style={{fontSize:'1.5rem', marginLeft:'1rem'}}>{po.vendorCode&&(po.vendorCode.startsWith('9')||po.vendorCode.startsWith('6'))?'Vendor บริษัทในเครือ กลุ่มบริษัทดีทีจีโอ':''}</span></div>
            <ItemTable isCreate={isCreate} isEdit={(valueForm.status==1||valueForm.isFromVendor)?false:isEdit} change={props.change} />
          </React.Fragment> : null}
        <div style={{ height: '1rem' }} />
        <RowFields>
          <Field
            name='remark'
            label='Remark'
            type={type.textArea}
            component={FieldInput}
            editable={valueForm&&valueForm.isFromVendor?false:true}
          />
        </RowFields>
        {poReleaseDetail?
        <Modal
          open={showAlertNotGR}
          header='Alert!'
          content={`PO ${poReleaseDetail.purchaseOrderSapNumber}(${poReleaseDetail.poNewVersionDocNumber}) cannot create the goods/service receipt because DTGO is currently being modified, please wait until the PO is successfully modified.`}
          actions={[{ key: 'ok', content: 'OK', positive: true, onClick:()=>setShowAlertNotGR(false)}]}
        />:null
        }
      </StdCard>
      
    </GRContainer>
  )

}

const mapStateToProps = (state) => {
  let valueForm = getFormValues('formGR')(state)
  return {
    valueForm: valueForm,
    goaWorkFlow: state.gr.goaWorkFlow,
    poReleaseList: state.gr.poReleaseList,
    grType: state.gr.grType,
    grPaymentType: state.gr.grPaymentType,
    pmUsers: state.options.pmUsers,
    // projects: state.options.projects,
    members:state.member.members,
    specialApprovalInfo:state.gr.specialApprovalInfo,
    poReleaseDetail:state.gr.poReleaseDetail,
    specialApprovals:state.goa.specialApprovals,
    projects: state.goa.projects[valueForm.companyCode||""]||[],
    projectLoading: state.goa.projectLoading,
    specialApprovalLoading:state.goa.specialApprovalLoading,
  }
}

const mapDispatchToProps = {
  filterItemPORelease,
  removeItemPORelease,
  addItemPORelease,
  resetItemPORelease,
  getPOReleaseDetail,
  getSpecialApproval,
  getProjectByCompany
}

export default connect(mapStateToProps, mapDispatchToProps)(Information)
